/**********************************************************************************************************************/
/* FILE: display-fullmap/hafas_webapp_controller_print.js                                                             */
/**********************************************************************************************************************/
/* Controller PRINT */
HafasWebapp.prototype.Controller.PRINT = {
  common: {
    /**
     * Method stores the storageObj as a global object, so that the printview can use it. Opens the
     * printview in a new window and builds up the URL accordingly to the printviewMode(printviewConfiguration).
     * @method openPrintView
     * @param {Object} storageObj: datamodel fed to the template in printview
     * @param {Object} configuration: builds URL with this configuration so that printview can configure the
     *  print-template accordingly
     */
    openPrintView: function (storageObj, configuration) {
      var storageId = new Date().getTime();
      try {

        if (typeof globalPrintObj === 'undefined') {
          globalPrintObj = {};
        }
        globalPrintObj['print_' + configuration + '_' + storageId] = JSON.stringify(storageObj);
      }
      catch (e) {
        Hafas.logger.error(
          Hafas.logger.ERROR_TYPES.JSON,
          "print.openPrintView",
          'PRINT: Das Objekt konnte nicht gespeichert werden (' + configuration + ')',
          e
        );
      }

      // if L-Parameter is active, add it to the deeplink that opens the print view
      var layoutParam = '';
      if (Hafas.Core.getParameterByName("L") != null) {
        layoutParam = '&L=' + Hafas.Core.getParameterByName("L");
      }

      window.open('print.html?language=' + Hafas.Config.currLangObj.lang + '&mode=' + configuration + '&id=' + storageId + layoutParam, '_blank');
    }
  },

  tp: {
    /**
     * Method initializes the basic conditions to feed the right printviewObj to the printview-template.
     * With HDSWAPP-2216 the old easy printview was refactored to use the TP Configurator Template,
     * therefore the printviewMode is not used anymore to redirect control flow into a different template
     * but to manipulate the building process of the TP Configurator Template (hide unnecessary elements).
     *
     * @method initPrintview
     * @param {Object} opts.origin: is given through the actionbutton on the UI and determines the printview Mode
     */
    initPrintview: function (opts) {

      var _me = this;
      var templateConfiguration = (Hafas.Config.TP.useExtendedPrintview) ? 'tpConfigurator' : 'tp';
      var printviewObj = {};

      printviewObj = this.Controller.PRINT.tp.getPrintviewObj(opts, _me);

      this.Controller.PRINT.common.openPrintView(printviewObj, templateConfiguration);
    },

    /**
     * Method builds up the datamodel(printviewObj) for the printview.
     *
     * @method getPrintviewConnections
     * @param {Object} opts: contains checksum and if so printMode
     * @param {Object} instance: current instance is used to get the data results of the TP instance
     * @return {Object} printviewObj: Object that is fed to the template in printview
     */
    getPrintviewObj: function (opts, instance,) {

      var templateConfiguration = (Hafas.Config.TP.useExtendedPrintview) ? 'tpConfigurator' : 'tp';
      var printMode = (typeof opts.origin != 'undefined') ? opts.origin : '';
      var groupingUsed = instance.Controller.TP.instance.isGroupingUsed();
      var resultsObj = instance.Controller.TP.instance.data.results;
      var connections = [];
      var usedChecksums = {};

      if (templateConfiguration === 'tp') {
        // get connection overview data
        // use grouped object if grouping is active AND connection is not reconstructed
        if (groupingUsed && resultsObj.isReconstruction !== true) {
          Object.keys(resultsObj.groups).forEach(function (group) {
            resultsObj.groups[group].connections.forEach(function (currConn) {
              if (currConn.resolvedConnection.cksum === opts.connection) {
                connections.push(currConn.resolvedConnection);
              }
            });
          });
        } else {
          resultsObj.renderConnections.forEach(function (currConn) {
            if (currConn.cksum === opts.connection) {
              connections.push(currConn);
            }
          });
        }

        printviewObj = {
          creationDate : Hafas.Util.date.jsDate2string(new Date),
          creationTime : Hafas.Util.date.jsDate2timeString(new Date),
          results : {from:instance.Controller.TP.instance.data.results.from, to:instance.Controller.TP.instance.data.results.to},
          printMode : printMode,
          connections : connections
        };

      } else {

        // If printMode is not details, it is the print overview (multiple connections)
        if((printMode !== 'details')){

          if(groupingUsed  && resultsObj.isReconstruction !== true) {
            Object.keys(resultsObj.groups).forEach(function(group) {
              var connArr = [];
              var subclusterGrpId = instance.Controller.TP.activeSelection.subclusterGrpId;
              if (subclusterGrpId !== undefined && resultsObj.groups[group].subcluster !== undefined && resultsObj.groups[group].subcluster[subclusterGrpId] !== undefined) {
                // If subcluster is available, use connections of that cluster
                connArr = resultsObj.groups[group].subcluster[subclusterGrpId].connections;
              } else {
                // otherwise use connections directly from the group
                connArr = resultsObj.groups[group].connections;
              }
              connArr.forEach(function(currConn) {
                // Check duplicate connections by checking the hash map with the connection checksum
                if(typeof usedChecksums[currConn.resolvedConnection.cksum] === 'undefined') {
                  usedChecksums[currConn.resolvedConnection.cksum] = true;
                  connections.push(currConn.resolvedConnection);
                }
              });
            });

          } else {
            connections = resultsObj.renderConnections;
          }
        } else {
         // otherwise use only one specific connection result for details print view
          if (groupingUsed  && resultsObj.isReconstruction !== true) {

            Object.keys(resultsObj.groups).forEach(function(group) {
              resultsObj.groups[group].connections.forEach(function(currConn) {
                // auf doppelte checksumme pruefen
                if (typeof usedChecksums[currConn.resolvedConnection.cksum] === 'undefined') {
                  if (currConn.resolvedConnection.cksum === opts.connection){
                    usedChecksums[currConn.resolvedConnection.cksum] = true;
                    connections.push(currConn.resolvedConnection);
                  }
                }
              });
            });
          } else {
            resultsObj.renderConnections.forEach(function(tmpConn){
              if(tmpConn.cksum === opts.connection){
                connections.push(tmpConn);
              }
            });
          }

        }

        printviewObj = {
          creationDate : Hafas.Util.date.jsDate2string(new Date),
          creationTime : Hafas.Util.date.jsDate2timeString(new Date),
          results : {from:instance.Controller.TP.instance.data.results.from, to:instance.Controller.TP.instance.data.results.to},
          connections : connections,
          printMode : printMode,
          query: resultsObj.query,
          requestDate: resultsObj.requestDate
        };
        if(typeof resultsObj.messagesResolved != 'undefined'){
          printviewObj.messagesResolved = resultsObj.messagesResolved;
        }

        // Enrich results with additional information for rendering the data in the template (indices, gis section flags, etc.
        printviewObj.connections.forEach( function(printConnection,connIdx) {
          // Calculate connection index for print template, print index is used for display, so it needs to be incremented by one
          printConnection.printIndex = (connIdx+1);
          printConnection.connIdx = connIdx.toString();

          // Check if opts.connection has been passed, it indicates that only one specific connection should be shown, all the other connections
          // won't be activated for print view
          printConnection.print = true;
          if(typeof opts.connection != 'undefined'){
            if((printConnection.cksum !== opts.connection) && Hafas.Config.Print.useToolbox){
              printConnection.print = false;
            }
          }

          // Check if connection is a gis route with only one section
          if((printConnection.secL.length === 1) && (typeof printConnection.secL[0].gis != 'undefined')){
            printConnection.gisSection = true;
          }

          // Check if connection starts on the next day
          if(printConnection.arr.aTimeS.length > 6){
            printConnection.arrDate = Hafas.Util.date.jsDate2hciDate(Hafas.Util.date.hciDate2jsDate(printConnection.date,printConnection.arr.aTimeS)).hciDate;
          }

          // calculate duration for every section
          printConnection.secL.forEach(function(section,sectIdx){
            var tmpDuration = Hafas.Util.getHciTimeDiff(section.arr.aTimeS,section.dep.dTimeS);
            var tmpHours = Math.floor(tmpDuration/60);
            var tmpMinutes = tmpDuration%60;
            if(tmpMinutes < 10){
              tmpMinutes = '0'+tmpMinutes;
            }
            section.dur = tmpHours+':'+tmpMinutes;
            section.printIndex = printConnection.printIndex;
            section.connIdx = connIdx.toString();
            section.sectionIndex = sectIdx.toString();
            if(printConnection.gis){
              section.gisConnection = true;
            }

            // Resolve distances of gis sections, units are being calculated
            if((typeof section.gis != 'undefined') && (typeof section.gis.segL != 'undefined')){
              section.gis.segL.forEach(function(segment,segIdx){
                if (segment.dist !== undefined) {
                  var hciDistance = Hafas.Util.getDistanceInUnit(segment.dist, Hafas.Config.Switches.lengthUnit);
                  segment.unitDistanceResolved = hciDistance.unit;
                  segment.unitDistanceLongResolved = hciDistance.unitLong;
                  segment.distResolved = hciDistance.dist;
                }
                segment.printIndex = printConnection.printIndex;
                segment.connIdx = connIdx.toString();
                segment.sectionIndex = sectIdx.toString();
                segment.segmentIndex = segIdx.toString();
              });
            }
          });

          // Single section connections receive a flag to identify them for later usage in the template
          // They won't receive extra map button options, since they are displayed with a map anyway
          if(printConnection.secL.length == 1){
            printConnection.secL[0].singleSection = true;
          }
        });
      }

      return printviewObj;
    }
  },


  jt: {
    errorOverview: function (opts) {
      if (opts.ev) {
        opts.ev.preventDefault();
      }

      var _me = this;
      var printWindow = null;

      var journeyTreeErrors = {};
      var template = "";
      if ((typeof opts.type != undefined) && (opts.type == "err_grouping")) {
        journeyTreeErrors.title = "Auflistung aller Fehler im Fahrtenbaum (Sortierung: Fehler)";
        journeyTreeErrors.groupedErrorList = _me.Controller.JT.resultData.minimizedErrorList;
        journeyTreeErrors.grouping = "errors";
      } else {
        journeyTreeErrors.title = "Auflistung aller Fehler im Fahrtenbaum (Sortierung: Pfade)";
        journeyTreeErrors.errorList = _me.Controller.JT.errorLog;
        journeyTreeErrors.grouping = "paths";
      }
      template = "JT_TplPrintErrorOverview";
      Hafas.Modules.Render.render({
        file: 'jt.print_errorOverview.html',
        template: template,
        model: journeyTreeErrors
      }, function (html) {

        // open javascript popup
        printWindow = window.open('', 'PrintOverview', 'resizable=yes,scrollbars=yes,status=yes', false);

        // clear content if popup is still open
        printWindow.document.getElementsByTagName('body')[0].innerHTML = '';

        // write new content
        printWindow.document.write(html);
        printWindow.document.close();

        if (!printWindow.opener) {
          printWindow.opener = self;
        }
        if (printWindow.focus()) {
          printWindow.focus();
        }
      });
    }
  },

  sq: {
    init: function (opts) {
      var printviewObj = {
        resolvedData: this.Controller.SQ.instance.resolvedData
      };

      this.Controller.PRINT.common.openPrintView(printviewObj, 'sq');
    }

  },

  timetable: {
    printTables: function (opts) {
      var result = this.Controller.Timetable.result;
      var printviewObj = {
        result: result
      };

      this.Controller.PRINT.common.openPrintView(printviewObj, 'timetable');
    }
  }
};
